import './confirmation-term.scss';

export default function ConfirmationTerm() {
    return (
        <div className="confirmation-term-page">
            <header className="confirmation-term-header">
                <h1>TERMO DE CONFIRMAÇÃO</h1>
                <p>
                    Ao ler e concordar, estará assumindo as responsabilidades do
                    acordo comercial da AmBev.
                </p>
            </header>

            <section>
                <h2>ACORDO COMERCIAL</h2>
                <p>
                    O Proponente Vencedor será responsável pela execução da
                    demanda, atendendo os quesitos de preço, disponibilidade de
                    veículos (carros/dia), nível de serviço, segurança do
                    transporte, seguro da carga e demais condições comerciais e
                    jurídicas.
                </p>

                <h2>CONDIÇÕES DE PAGAMENTO</h2>
                <p>
                    Em decorrência do acordo comercial, a AmBev pagará ao
                    proponente vencedor o(s) valor(es) definido(s) na respectiva
                    proposta vencedora do Leilão. Estas tarifas leiloadas são
                    referentes à tarifa líquida, ou seja, considera-se o preço
                    já com seguro obrigatório e seguro da carga e todos os
                    custos diretos e indiretos de qualquer espécie e natureza,
                    exceto as tarifas tributárias de PIS/Cofins e ICMS e Vale
                    Pedágio, que venham a incidir sobre o objeto desta
                    contratação (“Preço”).
                </p>
                <p>
                    Fica desde já certo e acordado que o direito ao recebimento
                    do preço estará vinculado ao devido cumprimento das
                    obrigações do proponente vencedor previstas nesta carta
                    convite, tais como, mas não se limitando, a de executar os
                    serviços de acordo com o estipulado nesta carta convite, e
                    em seus anexos.
                </p>

                <h2>SEGURO</h2>
                <p>
                    Ao aceitar o leilão eletronicamente por intermédio do
                    portal, o que significa a sua assinatura eletrônica, o
                    proponente garante possuir apólice de seguro RCTR-C e RCF-DC
                    vigentes, se compromete a averbar cada carga/pedido(s) que
                    porventura venha a transportar e a enviar mês a mês para a
                    Mesa de Fretes (CSC), o comprovante de pagamento e relatório
                    detalhado em papel timbrado da Seguradora constando todas as
                    cargas AmBev averbadas.
                </p>

                <h2>ATENDIMENTO</h2>
                <p>
                    O proponente vencedor será avaliado pelo seu nível de
                    atendimento.
                </p>
                <p>
                    No caso de não atendimento do acordado após o fechamento do
                    leilão, o proponente poderá ser excluído da base de
                    fornecedores da AmBev, e referido inadimplemento acabará por
                    inviabilizar a manutenção da relação comercial com esta
                    empresa, sem prejuízo das demais penalidades contratualmente
                    previstas e da obrigação legal de ressarcimento por todos os
                    danos eventualmente causados à AmBev.
                </p>

                <h2>OBRIGAÇÕES DECORRENTES DA CONDIÇÃO DE TRANSPORTADORA</h2>
                <p>
                    Responsabilizar-se pela permanente supervisão, controle,
                    direção técnica e fiscalização de seus empregados utilizados
                    nos serviços, não cabendo à AmBev qualquer encargo
                    administrativo, de horário, ou disciplinar.
                </p>
                <p>
                    Manter atualizado seu cadastro de fornecedor junto à AmBev.
                </p>
                <p>
                    Arcar com os tributos de sua responsabilidade, incidentes
                    sobre o objeto contratado, de natureza federal, estadual e
                    municipal, bem como se responsabilizar pelas infrações
                    fiscais decorrentes da execução do contrato a que tenha dado
                    causa.
                </p>
                <p>
                    Responsabilizar-se pela indenização por danos, diretos ou
                    indiretos, que, comprovadamente e em virtude da execução do
                    contrato, por culpa (negligência, imperícia, imprudência) ou
                    dolo, vier a causar à AmBev ou a terceiros alheios à relação
                    contratual, por ato próprio ou de seus empregados,
                    subcontratados ou colaboradores.
                </p>
                <p>
                    Responsabilizar-se integralmente pelas obrigações que vier a
                    contrair perante terceiros durante e em virtude da execução
                    do contrato, isentando a AmBev de quaisquer
                    responsabilidades decorrentes desse fato.
                </p>
                <p>
                    Garantir igualdade de tratamento a todos os seus empregados,
                    sem discriminação de qualquer tipo, em função de origem,
                    sexo, raça, convicções filosóficas, políticas ou religiosas,
                    crença, idade, entre outras.
                </p>
                <p>
                    Combater e se abster de praticar, bem como não subcontratar
                    e/ou manter relações negociais com quaisquer empresas que
                    utilizem, explorem e/ou empreguem qualquer forma de
                    degradação das condições de trabalho, exploração de trabalho
                    escravo ou infantil, trabalho forçado, recrutamento ilegal e
                    manutenção de trabalhadores em condições análogas a de
                    escravo.
                </p>
                <p>
                    Realizar suas atividades norteada pelos princípios do
                    desenvolvimento sustentável, prevenção contra a poluição e
                    preservação de seres vivos e recursos naturais.
                </p>
                <p>
                    A transportadora deverá fornecer e fiscalizar as instalações
                    dos empregados e demais trabalhadores que lhe prestarem
                    serviços, incluindo, mas não se limitando a alojamentos,
                    refeitórios, sanitários e demais condições necessárias à
                    segurança do trabalho e meio ambiente para a adequada
                    execução do Contrato, a fim de atender rigorosamente ao
                    quanto disposto na Portaria nº 1343 de 2019, especialmente
                    às seguintes determinações:
                </p>
                <h3 className="confirmation-term-sub-item">
                    Instalações sanitárias
                </h3>
                <p className="confirmation-term-sub-item">
                    Separação por gênero;
                </p>
                <p className="confirmation-term-sub-item">
                    Gabinetes sanitários privativos, dotados de portas de acesso
                    que impeçam o devassamento, com dispositivo de fechamento,
                    além de cesta de lixo e papel higiênico;
                </p>
                <p className="confirmation-term-sub-item">
                    Lavatórios dotados de materiais para higienização e secagem
                    das mãos;
                </p>
                <p className="confirmation-term-sub-item">
                    Dotar chuveiros com água fria e quente;
                </p>
                <p className="confirmation-term-sub-item">
                    Seguir a proporção mínima de 1 (um) gabinete sanitário, 1
                    (um) chuveiro e 1 (um) lavatório, por sexo, para cada 20
                    (vinte) vagas ou fração, considerando a quantidade de vagas
                    no estacionamento destinadas ao atendimento dos motoristas
                    profissionais de transporte;
                </p>
                <p className="confirmation-term-sub-item">
                    Ser providos de rede de iluminação; e
                </p>
                <p className="confirmation-term-sub-item">
                    Ser mantidas em adequadas condições de higiene, conservação,
                    funcionamento e organização.
                </p>
                <h3 className="confirmation-term-sub-item">Chuveiros</h3>
                <p className="confirmation-term-sub-item">Ser individuais;</p>
                <p className="confirmation-term-sub-item">
                    Dotar de portas de acesso que impeçam o devassamento, com
                    dispositivo de fechamento;
                </p>
                <p className="confirmation-term-sub-item">
                    Possuir ralos sifonados com sistema de escoamento que impeça
                    a comunicação das águas servidas entre os compartimentos e
                    que escoe toda a água do piso; e
                </p>
                <p className="confirmation-term-sub-item">
                    Dispor de suporte para sabonete e cabide para toalha.
                </p>
                <h3 className="confirmation-term-sub-item">Refeições</h3>
                <p className="confirmation-term-sub-item">
                    Os ambientes para refeições, quando existirem, podem ser de
                    uso exclusivo ou compartilhado com o público em geral,
                    devendo sempre:
                </p>
                <p className="confirmation-term-sub-item-2">
                    a) ser dotados de mesas e assentos;
                </p>
                <p className="confirmation-term-sub-item-2">
                    b) ser mantidos em adequadas condições de higiene, limpeza e
                    conforto; e
                </p>
                <p className="confirmation-term-sub-item-2">
                    c) permitir acesso fácil às instalações sanitárias e às
                    fontes de água potável.
                </p>
                <p>
                    A transportadora deverá fiscalizar a jornada de trabalho dos
                    motoristas para que atendam rigorosamente à Lei nº 13.103 de
                    2015, especialmente às seguintes determinações:
                </p>
                <p className="confirmation-term-sub-item">
                    8 (oito) horas diárias, com intervalo de 1 (uma) hora para
                    refeição, admitindo-se a prorrogação da jornada por até mais
                    2 (duas) horas diárias, que devem ser pagas como
                    extraordinárias.
                </p>
                <p className="confirmation-term-sub-item">
                    Intervalo mínimo de 1 (uma) hora para refeição, podendo esse
                    período coincidir com o tempo de parada obrigatória.
                </p>
                <p className="confirmation-term-sub-item">
                    Intervalo de 11 (onze) horas de descanso dentro do período
                    de 24 (vinte e quatro) horas, sendo facultado o seu
                    fracionamento e a coincidência com os períodos de parada
                    obrigatória na condução do veículo, desde que garantido o
                    mínimo de 8 (oito) horas ininterruptas no primeiro período e
                    o gozo do remanescente dentro das 16 (dezesseis) horas
                    seguintes ao fim do primeiro período.
                </p>
                <p className="confirmation-term-sub-item">
                    Quando o tempo de espera for superior a 2 (duas) horas
                    ininterruptas e for exigida a permanência do motorista junto
                    ao veículo, o tempo poderá considerado como de repouso,
                    desde que o local ofereça condições adequadas.
                </p>
                <p>
                    A transportadora deverá manter todas as certidões em
                    situação regular perante os órgãos competentes, incluindo as
                    listadas abaixo, sob pena de ter a sua participação
                    bloqueada de imediato do Leilão até que a certidão seja
                    regularizada:
                </p>
                <p className="confirmation-term-sub-item">
                    Certidão de Falência e Concordata;
                </p>
                <p className="confirmation-term-sub-item">
                    Certidão de Regularidade da Receita Estadual;
                </p>
                <p className="confirmation-term-sub-item">
                    Certidão de Regularidade da Receita Federal;
                </p>
                <p className="confirmation-term-sub-item">
                    Certidão de Regularidade da Receita Municipal;
                </p>
                <p className="confirmation-term-sub-item">
                    Certificado de Regularidade do FGTS;
                </p>
                <p className="confirmation-term-sub-item">
                    Certidão Negativa de Débitos Trabalhistas (“CNDT”);
                </p>
                <p className="confirmation-term-sub-item">
                    Certidão eletrônica de Débitos Trabalhistas fornecida pelo
                    MTE;
                </p>
                <p className="confirmation-term-sub-item">
                    Certidão negativa de débitos Cíveis.
                </p>
                <p>
                    A transportadora declara conhecer a Política de Direitos
                    Humanos da AmBev, disponível em{' '}
                    <a
                        href="https://ri.ambev.com.br/governanca-corporativa/policies-codes-and-internal-regulations/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        https://ri.ambev.com.br/governanca-corporativa/policies-codes-and-internal-regulations/
                    </a>
                    , e compromete-se a cumpri-la integralmente.
                </p>
                <p>
                    A transportadora declara plena ciência de que a AmBev poderá
                    fiscalizar, solicitar documentos e realizar auditorias in
                    loco em suas dependências a qualquer tempo,
                    independentemente de prévio aviso ou notificação, ainda que
                    não expressamente indicados no Edital, para que seja
                    avaliada a sua regularidade jurídica.
                </p>

                <h2>ESTADIAS</h2>
                <p>
                    A transportadora, aceitando a participação no Leilão e o
                    fornecimento de transporte como empresa selecionada, e
                    exercendo autonomia contratual no exercício da sua atividade
                    econômica, observados os preceitos da Lei nº 13.874/2019, ou
                    outra que venha a substitui-la, acorda que as estadias por
                    atraso em carga ou descarga em unidades da AmBev serão
                    devidas da seguinte forma:
                </p>
                <p className="confirmation-term-sub-item">
                    a) Transporte de Produtos Acabados (PA) – A transportadora
                    não cobrará estadias em tal modalidade de transporte e
                    carga;
                </p>
                <p className="confirmation-term-sub-item">
                    b) Transporte de insumos (exceto malte e high maltose) – A
                    transportadora poderá cobrar estadia somente após a retenção
                    do veículo por prazo superior a 24 (vinte e quatro) horas,
                    incidindo, nesse caso, o valor previsto na Lei nº
                    11.442/2007 pelo tempo que exceder o prazo previsto nesta
                    cláusula;
                </p>
                <p className="confirmation-term-sub-item">
                    c) Transporte de high maltose - A transportadora poderá
                    cobrar estadia somente após a retenção do veículo por prazo
                    superior a 48 (quarenta e oito) horas, incidindo, nesse
                    caso, o valor previsto na Lei nº 11.442/2007 pelo tempo que
                    exceder o prazo previsto nesta cláusula;
                </p>
                <p className="confirmation-term-sub-item">
                    d) Não serão computadas como início do prazo, no cálculo de
                    estadias, as hipóteses de cargas que chegarem nas
                    cervejarias aos domingos e feriados;
                </p>
                <p className="confirmation-term-sub-item">
                    e) Caso o transportador chegue antes do dia programado de
                    descarga, o cálculo de estadia irá considerar como termo
                    inicial o dia que foi programado e o disposto no nos itens
                    acima;
                </p>
                <p className="confirmation-term-sub-item">
                    f) Caso o transportador chegue após o dia programado de
                    descarga, exceto nos casos em que a AmBev seja previamente
                    comunicada com antecedência de {'{2}'} dias pela
                    transportadora, a estadia não poderá ser cobrada, em vista
                    da necessidade de reorganização da grade para atendimento;
                </p>
                <p className="confirmation-term-sub-item">
                    g) Em caso de chegada em comboio (caracterizado por chegada
                    em tempos próximos de veículos com mesmo tipo de produto e
                    da mesma transportadora), o próximo veículo terá seu termo
                    inicial somente após período factível para a descarga do
                    veículo anterior para o produto transportado, podendo ser
                    acumulado de acordo com a chegada de mais veículos em
                    horários próximos;
                </p>
                <p className="confirmation-term-sub-item">
                    h) O dia programado de descarga de insumo é considerado: o
                    dia de entrega do pedido enviado pelo time de insumos AmBev;
                </p>
                <p className="confirmation-term-sub-item">
                    i) Também será considerado o Transit time do trajeto,
                    contado a partir da data e hora de emissão da nota fiscal na
                    origem. Para o Transit time, serão considerados no máximo
                    10h de deslocamento por dia, 1h de descanso a cada 4h
                    dirigidas e uma margem de atraso de 20% do tempo total até a
                    data de chegada calculada, não podendo ser inferior a 1h e
                    superior a 12h;
                </p>
                <p className="confirmation-term-sub-item">
                    j) É restrita a solicitação de somente 1 (uma) estadia por
                    Conhecimento de Transporte Eletrônico (CTe). Sendo inválidas
                    as demais solicitações além da primeira;
                </p>
                <p className="confirmation-term-sub-item">
                    k) Caso no momento da carga/descarga seja identificado algum
                    destes eventos, a estadia será invalidada:
                </p>
                <p className="confirmation-term-sub-item-2">
                    i. Veículo ausente no momento da chamada;
                </p>
                <p className="confirmation-term-sub-item-2">
                    ii. Avaria de mercadoria;
                </p>
                <p className="confirmation-term-sub-item-2">
                    iii. Veículo quebrado;
                </p>
                <p className="confirmation-term-sub-item">
                    l) Toda solicitação de estadia deve ser realizada através de
                    chamado pelo portal now (
                    <a
                        href="https://now.ambev.com.br"
                        target="_blank"
                        rel="noreferrer"
                    >
                        https://now.ambev.com.br
                    </a>
                    {'). '}
                </p>
                <p className="confirmation-term-sub-item">
                    m) Serão considerados indevidos qualquer custo de estadia
                    sem um respectivo chamado com status aprovado.
                </p>
                <p className="confirmation-term-sub-item">
                    n) Para emissão de CTE complementar de estadia o valor
                    líquido deve ser exato ao aprovado no chamado.
                </p>
                <p className="confirmation-term-sub-item">
                    o) É fundamental a utilização do sistema e-gates para a
                    validação dos horários de entrada e saída da cervejaria.
                    Para a análise do custo de estadia, chamados com a
                    utilização do e-gates serão priorizados. Caso a
                    transportadora não utilize o sistema, a mesa de fretes pode
                    descadastrar as tarifas do trecho e abrir novo leilão.
                </p>
                <p className="confirmation-term-sub-item">
                    p) Todo veículo deve espelhar seu monitoramento em tempo
                    real para a área responsável da AmBev, independentemente de
                    ser frota própria ou subcontratação. Caso a transportadora
                    não compartilhe o monitoramento, a mesa de fretes pode
                    descadastrar as tarifas do trecho e abrir novo leilão.
                </p>

                <h2>VALE PEDÁGIO</h2>
                <p>
                    (a) Considerando a Lei de Vale-Pedágio (LEI No 10.209, DE 23
                    DE MARÇO DE 2001.) e o Acordo Comercial celebrado entre as
                    Partes, o Proponente Vencedor declara e garante que:
                </p>
                <p className="confirmation-term-sub-item">
                    i) tem ciência e concorda que o sistema utilizado pela AmBev
                    para disponibilização prévia do Vale-Pedágio à
                    transportadora consiste na disponibilização do crédito do
                    pedágio nas TAGs de empresas fornecedoras de sistemas de
                    vale-pedágio, inclusive, mas não se limitando a, (i) Sem
                    Parar; e (ii) Veloe;
                </p>
                <p className="confirmation-term-sub-item">
                    ii) possui e compromete-se a manter ativo e em condições de
                    uso, em todos os seus veículos que prestam serviços para
                    AmBev, o TAG para pagamento automático de pedágios de pelo
                    menos uma das empresas indicadas no item (a);
                </p>
                <p className="confirmation-term-sub-item">
                    iii) substituirá imediatamente qualquer TAG que apresentar
                    problemas de funcionamento, comprometendo-se a
                    disponibilizar para prestação de serviços logísticos somente
                    os veículos com TAG operante e ativos;
                </p>
                <p className="confirmation-term-sub-item">
                    iv) responsabiliza-se por manter atualizadas as informações
                    relativas aos veículos e TAGs utilizados na operação, bem
                    como por comunicar imediatamente qualquer alteração ou
                    indisponibilidade que possa impactar a emissão ou utilização
                    do vale-pedágio;
                </p>
                <p className="confirmation-term-sub-item">
                    v) reconhece e concorda que a disponibilização do
                    vale-pedágio por meio de crédito em TAGs de operadoras
                    habilitadas atende aos requisitos operacionais necessários
                    para realização dos transportes contratados pela AmBev;
                </p>
                <p className="confirmation-term-sub-item">
                    vi) nas situações em que o fluxo regular de disponibilização
                    do Vale-Pedágio não for aplicável, a AmBev poderá realizar a
                    disponibilização dos valores correspondentes por meio
                    alternativo.
                </p>

                <h2>PREÇOS</h2>
                <p>
                    Os preços dos serviços, serão acordados previamente à
                    execução do leilão de Aceite de Cargas;
                </p>

                <h2>VALIDADE</h2>
                <p>
                    O acordo comercial será válido pelo período estipulado
                    previamente à execução do leilão. O acordo estará ativo após
                    a realização do leilão.
                </p>

                <h2>ACIONAMENTO</h2>
                <p>
                    Somente depois de finalizado o leilão e o proponente
                    vencedor ter aceitado as cláusulas contidas no sistema, a
                    AmBev realizará as ofertas de transporte de carga, a partir
                    de agora denominadas “acionamentos”.
                </p>
                <p>
                    Cada acionamento será referente à oferta de uma viagem
                    (origem x destino).
                </p>
                <p>O acionamento é feito assim que este acordo for aceito.</p>
                <p>
                    O follow do carregamento além de informações adicionais
                    sobre o carregamento, como status e pedido, será de
                    explícita responsabilidade do solicitante cujo e-mail estará
                    no relatório do leilão.
                </p>
                <p>
                    Caso seja identificada pela AmBev eventual irregularidade
                    trabalhista ou previdenciária da transportadora, a AmBev
                    poderá, a seu exclusivo critério, bloquear de imediato a sua
                    participação do Leilão e/ou prestação de serviço de
                    transporte rodoviário até que a situação identificada seja
                    regularizada.
                </p>
                <p>
                    A Transportadora deve apresentar o carro na unidade Ambev
                    somente da data indicada do SmartCargas para carregamento e
                    com o pedido confirmado, transportadoras que apresentam o
                    carro sem pedido confirmado e entram no raio da Unidade
                    Ambev podem ser punidas com bloqueio;
                </p>
                <p>
                    Logo após o carregamento ou descarga do carro nas unidades
                    Ambev a transportadora deve retirar o mesmo do raio da
                    unidade Ambev, não está autorizado ficar aguardando dentro
                    do raio para questões internas da transportadora, deve ser
                    procurado um pátio externo, fora do raio Ambev;
                </p>

                <h2>CONDIÇÕES DE PAGAMENTO</h2>
                <p>
                    (a.1) Transporte de produto acabado entre unidades Ambev:
                    Pelos Serviços, a AmBev pagará ao proponente vencedor o(s)
                    valor(es) definido(s) na respectiva proposta vencedora do
                    Leilão. Estas tarifas leiloadas são referentes à tarifa
                    líquida sem custo de pedágio (será pago com vale pedágio ou
                    outros custos), ou seja, considera-se o preço já com seguro
                    obrigatório e seguro da carga e todos os custos diretos e
                    indiretos de qualquer espécie e natureza, exceto as tarifas
                    tributárias de PIS/Cofins e ICMS, que venham a incidir sobre
                    o objeto desta contratação (“Preço”).
                </p>
                <p>
                    (a.2) Transporte de outros materiais: Pelos Serviços, a
                    AmBev pagará ao proponente vencedor o(s) valor(es)
                    definido(s) na respectiva proposta vencedora do Leilão.
                    Estas tarifas leiloadas são referentes à tarifa líquida, ou
                    seja, considera-se o preço já com pedágios, seguro
                    obrigatório e seguro da carga e todos os custos diretos e
                    indiretos de qualquer espécie e natureza, exceto as tarifas
                    tributárias de PIS/Cofins e ICMS, que venham a incidir sobre
                    o objeto desta contratação (“Preço”).
                </p>
                <p>
                    (b) Fica desde já certo e acordado que o direito ao
                    recebimento do preço estará vinculado ao devido cumprimento
                    das obrigações do proponente vencedor previstas nesta carta
                    convite, tais como, mas não se limitando, a de executar os
                    serviços de acordo com o estipulado nesta carta convite, e
                    em seus anexos.
                </p>
                <p>
                    (c) Pagamentos são realizados em data fixa (primeiro dia
                    útil de cada mês). O (A) fornecedor (a) está ciente da
                    proibição da cessão de créditos originados dos contratos e
                    pedidos de compra realizados junto à Ambev e suas empresas
                    subsidiárias. Qualquer ressalva a esta regra demanda prévia
                    e expressa autorização por escrito da Ambev.
                </p>

                <h2>COMPLIANCE ANTICORRUPÇÃO</h2>
                <h3>Declarações e garantias:</h3>
                <p>
                    A Proponente Vencedora declara e garante, para todos os
                    efeitos legais e contratuais que:
                </p>
                <p className="confirmation-term-sub-item">
                    a) Cumpre de forma irrestrita e integral com toda a
                    Legislação Anticorrupção Aplicável, conforme definida
                    adiante;
                </p>
                <p className="confirmation-term-sub-item">
                    b) Nenhum de seus sócios, administradores, diretores,
                    gerentes, conselheiros, empregados ou subcontratados
                    ofereceram, prometeram ou deram, direta ou indiretamente,
                    vantagem indevida a funcionário público[1], bem como durante
                    a vigência do objeto do presente Edital, no exercício de
                    suas responsabilidades e obrigações, a Proponente Vencedora
                    ou qualquer sócios, administradores, diretores, gerentes,
                    conselheiros, empregados e subcontratados não irão, direta
                    ou indiretamente, oferecer, prometer ou dar vantagem
                    indevida a funcionário público.
                </p>
                <p className="confirmation-term-sub-item">
                    c) Não foi, tampouco seus sócios, administradores,
                    diretores, gerentes, conselheiros, empregados e
                    subcontratados foram, objeto de investigação relacionada ao
                    descumprimento de leis anticorrupção nos últimos 5 (cinco)
                    anos, sendo que suas atividades não ensejariam qualquer tipo
                    de investigação do gênero.
                </p>
                <p className="confirmation-term-sub-item">
                    d) Nenhum de seus acionistas, administradores, sócios,
                    diretores, gerentes, conselheiros, empregados ou
                    subcontratados é funcionário público. Caso qualquer dessas
                    pessoas passe a ser funcionário público no decorrer da
                    vigência do objeto deste Edital, a Proponente Vencedora
                    compromete-se a informar à AmBev neste sentido no prazo de
                    até 5 (cinco) dias a partir da data de ocorrência do fato.
                </p>
                <h3>Obrigações da Proponente Vencedora:</h3>
                <p>
                    São obrigações da Proponente Vencedora, sem prejuízo de
                    outras específicas previstas no Edital e Anexos, bem como na
                    legislação pertinente:
                </p>
                <p className="confirmation-term-sub-item">
                    a) Respeitar e estar estritamente em conformidade com todas
                    as regras da Contratante relacionadas ao combate e prevenção
                    da corrupção e a legislação nacional ou estrangeira
                    aplicável relativa às práticas de corrupção, incluindo, mas
                    não se limitando, ao U.S. Foreign Corrupt Practices Act of
                    1977 (FCPA), à Lei nº 12.846/13 (Lei Anticorrupção) e suas
                    regulamentações, ao Código Penal Brasileiro e à Lei nº
                    8.429/92 (Lei de Improbidade Administrativa) e a qualquer
                    outra lei ou regulamentação aplicável (“Legislação
                    Anticorrupção Aplicável”);
                </p>
                <p className="confirmation-term-sub-item">
                    b) Manter com veracidade, precisão e de forma completa os
                    livros e registros relacionados, direta ou indiretamente, a
                    todos os pagamentos feitos a terceiros em razão da execução
                    do objeto do Edital.
                </p>
                <h3>Do direito à auditoria financeira:</h3>
                <p className="confirmation-term-sub-item">
                    a) A qualquer momento durante a vigência do objeto deste
                    Edital e por um período de até 5 (cinco) anos após o seu
                    término ou rescisão, a AmBev ou seus representantes terão o
                    direito de realizar uma auditoria financeira na Proponente
                    Vencedora com relação ao objeto do presente Edital, com
                    acesso a livros, registros e documentos, bem como os
                    sistemas e as instalações físicas em que tais livros,
                    registros e documentos estiverem armazenados. As auditorias
                    ocorrerão a qualquer tempo, nas dependências da Proponente
                    Vencedora, mediante o envio de notificação por escrito nesse
                    sentido pela AmBev à Proponente Vencedora.
                </p>
                <p className="confirmation-term-sub-item">
                    b) A AmBev poderá conduzir esta auditoria por meio dos seus
                    auditores qualificados, auditores independentes ou quaisquer
                    terceiros contratados (“Auditores”). A Proponente Vencedora
                    neste ato concorda em cooperar com a auditoria da AmBev e em
                    fornecer imediatamente assistência e acesso total,
                    irrestrito e ilimitado a todas as informações solicitadas
                    pela AmBev ou pelos Auditores que estejam diretamente
                    relacionadas ao objeto do presente Edital.
                </p>
                <p className="confirmation-term-sub-item">
                    c) A Proponente Vencedora concorda em fornecer à AmBev e/ou
                    aos seus Auditores o acesso a sistemas e locais onde os
                    documentos e informações relacionados diretamente ao objeto
                    deste Edital estejam armazenados, seja em modo físico ou
                    eletrônico. Durante a auditoria, a Proponente Vencedora
                    permitirá que a AmBev e/ou seus Auditores copiem tais
                    documentos e informações de forma irrestrita.
                </p>
                <p className="confirmation-term-sub-item">
                    d) A AmBev compromete-se que a auditoria realizada não
                    interfira nas atividades regulares da Proponente Vencedora.
                </p>

                <h2>PRIVACIDADE E PROTEÇÃO DE DADOS PESSOAIS</h2>
                <p>
                    a) As Partes se comprometem a tratar os dados pessoais a que
                    tiveram acesso em decorrência do presente acordo, única e
                    exclusivamente para cumprir com a finalidade a que se
                    destina seu tratamento e em respeito a toda a legislação
                    aplicável sobre segurança da informação, privacidade e
                    proteção de dados, inclusive, a Lei Federal n. 13.709/2018 -
                    Lei Geral de Proteção de Dados (“LGPD”), sem exclusão das
                    demais normas setoriais ou gerais sobre os temas.
                </p>
                <p>
                    b) As Partes deverão tratar os dados pessoais como
                    informações confidenciais, responsabilizando-se por quem
                    quer que venha acessá-los, garantindo mutuamente que tais
                    pessoas estejam sujeitas a idêntico dever de
                    confidencialidade e a regras não menos rigorosas que aquelas
                    estabelecidas no âmbito do acordo.
                </p>

                <h2>CONFORMIDADE DO VEÍCULO APRESENTADO</h2>
                <p>
                    A transportadora se compromete a apresentar, no momento do
                    carregamento, veículo do mesmo tipo e com características
                    compatíveis àquele informado e aceito no ato da confirmação
                    da carga na plataforma, incluindo, sem limitação, a
                    quantidade de eixos.
                </p>
                <p>
                    Caso seja identificado o envio de veículo divergente do
                    aceito, a contratante poderá, a seu exclusivo critério,
                    recusar o carregamento, solicitar a adequação do veículo ou
                    aplicar as penalidades previstas neste Termo, sem prejuízo
                    de outras medidas cabíveis.
                </p>

                <h2>EMISSÃO DE CIOT NO MDF-e</h2>
                <p>
                    Nos casos em que a emissão do MDF-e for de responsabilidade
                    da transportadora e não for realizada por meio do sistema
                    Unidocs (ou solução equivalente da contratante), a
                    transportadora se obriga a emitir o CIOT correspondente à
                    operação e a incluí-lo corretamente no MDF-e, em
                    conformidade com a legislação vigente.
                </p>
                <p>
                    O descumprimento desta obrigação poderá acarretar a
                    aplicação de penalidades previstas neste Termo, bem como
                    responsabilização da transportadora por eventuais impactos
                    legais, operacionais ou financeiros incorridos pela AmBev e
                    decorrentes do referido descumprimento.
                </p>

                <h2>RESCISÃO</h2>
                <p>
                    Não obstante o disposto de forma diversa em qualquer outra
                    cláusula ou item deste Edital, a AmBev poderá, sem prejuízo
                    da adoção de outras medidas cabíveis, rescindir de boa-fé o
                    presente Edital desde que:
                </p>
                <p className="confirmation-term-sub-item">
                    a) Demonstre o descumprimento pela Proponente Vencedora de
                    qualquer das cláusulas, condições, declarações ou garantias
                    acima, ainda que de forma integral ou parcial;
                </p>
                <p className="confirmation-term-sub-item">
                    b) Obtenha informações que sugiram o descumprimento pela
                    Proponente Vencedora de qualquer das cláusulas, condições,
                    declarações ou garantias acima ou violação da legislação
                    anticorrupção aplicável; ou
                </p>
                <p className="confirmation-term-sub-item">
                    c) Tenha razões para acreditar que qualquer uma das
                    declarações e garantias prestadas acima são imprecisas ou
                    incompletas.
                </p>
                <p>
                    Em qualquer desses casos, a AmBev estará isenta do pagamento
                    de qualquer multa, indenização ou compensação à Proponente
                    Vencedora, podendo inclusive reter o pagamento de quaisquer
                    valores ainda devidos à Proponente Vencedora.
                </p>
                <p>
                    A Proponente Vencedora compromete-se a defender e indenizar
                    a AmBev por quaisquer perdas e/ou danos sofridos pela AmBev
                    resultantes ou relacionados ao acima previsto.
                </p>

                <p>Agradecemos a participação de sua empresa neste processo.</p>
                <p>Atenciosamente,</p>
                <p>AmBev.</p>

                <p className="confirmation-term-footnote">
                    [1] Considera-se funcionário público para fins deste
                    Contrato: (i) quem, ainda que transitoriamente ou sem
                    remuneração, exerça cargo, emprego ou função pública em
                    órgãos, entidades estatais ou em representações
                    diplomáticas, assim como em pessoas jurídicas controladas,
                    direta ou indiretamente, pelo poder público ou em
                    organizações públicas internacionais; (ii) partido político,
                    seu integrante, empregado, agente ou outra pessoa agindo
                    para ou em nome do partido político; ou (iii) candidato ou
                    pré-candidato a cargo político ou eletivo.
                </p>
            </section>
        </div>
    );
}
